<template>
  <scorecard-status-pill
    v-if="isValueOfScorecardStatusType(value)"
    :status="value"
    :readonly="readonly"
  />
  <span v-else>-</span>
</template>

<script setup lang="ts">
import isObjectLike from "lodash/isObjectLike";

import ScorecardStatusPill from "@/components/scorecards/ScorecardStatusPill.vue";

import type { IScorecardStatus } from "@/models/scorecards";
import type { PropType } from "vue";

defineProps({
  value: {
    type: [Object, String] as PropType<IScorecardStatus | string>,
    default: "",
  },
  readonly: {
    type: Boolean,
    default: true,
  },
});
const isValueOfScorecardStatusType = (
  value: string | IScorecardStatus
): value is IScorecardStatus =>
  isObjectLike(value) &&
  !Array.isArray(value) &&
  ["id", "name"].every((key) => Object.keys(value).includes(key));
</script>
